import { Link, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bot, LogOut, Sparkles } from 'lucide-react';
import Footer from '../components/Footer';
import { clearUserSession, getUserToken } from '../utils/auth';

const Dashboard = () => {
  const isLoggedIn = Boolean(getUserToken());

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const handleLogout = () => {
    clearUserSession();
    window.location.href = '/login';
  };

  return (
    <main className="bg-primary min-h-screen pt-28">
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="rounded-2xl p-8 sm:p-10"
          style={{
            background: 'linear-gradient(145deg, rgba(6, 11, 31, 0.92), rgba(10, 16, 41, 0.78))',
            border: '1px solid rgba(124, 77, 255, 0.2)',
          }}
        >
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-white">User Dashboard</h1>
              <p className="text-slate-400 mt-2">Login/Register successful. Welcome to your AI workspace.</p>
            </div>
            <button onClick={handleLogout} className="neon-btn neon-btn-outline" type="button">
              <LogOut className="w-4 h-4" />
              Logout
            </button>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            <div
              className="rounded-2xl p-6"
              style={{ background: 'rgba(10, 16, 41, 0.45)', border: '1px solid rgba(124, 77, 255, 0.12)' }}
            >
              <Sparkles className="w-6 h-6 text-ai-glow mb-3" />
              <h3 className="text-xl font-semibold text-white mb-2">Start AI Journey</h3>
              <p className="text-slate-400 text-sm mb-5">Explore consulting flow and get started with your AI roadmap.</p>
              <Link to="/contact" className="neon-btn neon-btn-primary no-underline">
                Go to Get Started
              </Link>
            </div>

            <div
              className="rounded-2xl p-6"
              style={{ background: 'rgba(10, 16, 41, 0.45)', border: '1px solid rgba(124, 77, 255, 0.12)' }}
            >
              <Bot className="w-6 h-6 text-ai-glow mb-3" />
              <h3 className="text-xl font-semibold text-white mb-2">AI Tools Access</h3>
              <p className="text-slate-400 text-sm mb-5">Browse services, case studies, and automation capabilities.</p>
              <Link to="/services" className="neon-btn neon-btn-outline no-underline">
                Explore Services
              </Link>
            </div>
          </div>
        </motion.div>
      </section>
      <Footer />
    </main>
  );
};

export default Dashboard;
